import clsx from "clsx";

const PureInput = ({ id, className, register, rules, ...rest }) => (
  <input {...rest} {...register(id, rules)} id={id} className={clsx("input", className)} />
);

export default PureInput;
